// App.jsx
import React from "react";
import { Routes, Route } from "react-router-dom";
import RestaurantPage from "./containers/restaurant/RestaurantPage";
import OrdersPage from "./containers/orders/OrdersPage";
import PaymentPage from "./containers/payment/PaymentPage";
import { Toaster } from "react-hot-toast";

function App() {
  return (
    <>
      <Toaster position="top-center" />
      <Routes>
        <Route path="/" element={<RestaurantPage />} />
        <Route path="/pedidos" element={<OrdersPage />} />
        <Route path="/pagar" element={<PaymentPage />} />
        {/* <Route path="/menu/comidas" element={<div>Menú Comidas</div>} />
      <Route path="/menu/bebidas" element={<div>Menú Bebidas</div>} /> */}
        <Route path="*" element={<div>Error 404 - Página no encontrada</div>} />
      </Routes>
    </>
  );
}

export default App;
